<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="成果名称" min-width="100" >
            <template slot-scope="scope">
              {{ scope.row.achievement_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="成果完成单位">
            <template slot-scope="scope">
              {{ scope.row.achievement_complete_unit || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="批准登记号">
            <template slot-scope="scope">
              {{ scope.row.approval_registration_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="批准登记单位">
            <template slot-scope="scope">
              {{ scope.row.approval_registration_unit || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="成果完成人">
            <template slot-scope="scope">
              {{ scope.row.achievement_task_completor || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="成果登记年份">
            <template slot-scope="scope">
              {{ scope.row.achievement_registration_year || '-' }}
            </template>
        </el-table-column>
         
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'techAchievementList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '科技成果',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>